(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('overrideMultiple', overrideMultiple);

    function overrideMultiple() {
        return function(value, override) {
            const val = JSON.parse(JSON.stringify(value));
            if (!(val instanceof Array)) {
                return val;
            }

            if (val.length == 1) {
                return val[0];
            }

            return override;
        };
    }
})();